import { render, staticRenderFns } from "./ActionComponent.vue?vue&type=template&id=53e97e0b&"
import script from "./ActionComponent.vue?vue&type=script&lang=js&"
export * from "./ActionComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports